<template>
  <NodePage v-if="entity?.__typename === 'NodePage'" v-bind="entity" />
  <NodePressRelease
    v-else-if="entity?.__typename === 'NodePressRelease'"
    v-bind="entity"
  />
</template>

<script lang="ts" setup>
defineOptions({
  name: 'PageNodeCanonical',
})

definePageMeta({
  name: 'node-canonical',
})

const { entity } = await useDrupalRouteQuery('nodeCanonical')

await renderPageDependencies()
</script>
